import { Component, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { fuseAnimations } from '@fuse/animations';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationDialogComponent } from 'app/services/user-interaction/components/confirmation-dialog/confirmation-dialog.component';
import { cloneDeep } from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';

import { CustomFuelInformation } from 'app/models/custom-fuel-information.model';
import { CompanyService } from 'app/services/company.service';
import { ToasterService } from '../../../../../services/user-interaction/services/toaster.service';
import { BaseFormComponent } from '../../base-form.component';
import { CompanyListComponent } from '../company-list/company-list.component';
import { CustomFuelInformationFormComponent } from '../custom-fuelInformation-form/custom-fuelInformation-form.component';
import { Company } from 'app/models/company.model';

@Component({
    selector: 'app-custom-fuelInformation-list',
    templateUrl: './custom-fuelInformation-list.component.html',
    styleUrls: ['./custom-fuelInformation-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class CustomFuelInformationListComponent extends BaseFormComponent implements OnInit {
    @ViewChild(MatSort) private _sort: MatSort;
    @ViewChild(MatPaginator) private _paginator: MatPaginator;

    constructor(
        private _dialog: MatDialog,
        private _spinner:NgxSpinnerService,
        private _companyService:CompanyService,
        public dialogRef: MatDialogRef<CompanyListComponent>,
        @Inject(MAT_DIALOG_DATA) public data :Company,
        private _toasterService: ToasterService,
        private _translateService:TranslateService
    ) {
        super();
    }

    private _fuelInformationList: Array<CustomFuelInformation> = [];
    public get fuelInformationList() {
        return this._fuelInformationList;
    }

    private _dataSource: MatTableDataSource<CustomFuelInformation> = undefined;
    public get dataSource(): MatTableDataSource<CustomFuelInformation> {
        return this._dataSource;
    }

    private _displayedColumns = ['city','gasoline','diesel', 'startDate', 'endDate', 'status', 'setting'];

    public get displayedColumns(): Array<string> {
        return this._displayedColumns;
    }
    public ngOnInit() {
        this.getFuelInformation();
    }

    public async getFuelInformation() {

        try {
            this._spinner.show('loading')
            this._fuelInformationList = await this._companyService.getCustomFuelInformation(this.data.id);
            this._spinner.hide('loading')
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);
        }
        await this.updateTableDataSource();
    }

    private async updateTableDataSource(): Promise<void> {
        this._dataSource = new MatTableDataSource<CustomFuelInformation>(this._fuelInformationList);
        this._dataSource.paginator = this._paginator;
        this._dataSource.sort = this._sort;
    }

    fuelInformationAdd() {
        const dialog = this._dialog.open(CustomFuelInformationFormComponent,
            {
                data: cloneDeep(this.data),
                disableClose: false,
                width:"800px"
            })
            dialog.componentInstance.fuelInformationList = cloneDeep(this.fuelInformationList);
        dialog.componentInstance.added.subscribe((model: boolean) => {
            model ? this._toasterService.toastSuccess() : this._toasterService.toastFail();
            this.refresh();
            dialog.close();
        });

    }

    async deleteFuelInformation(cfi: CustomFuelInformation) {
        try {
            const dialog = this._dialog.open(ConfirmationDialogComponent,{

            })
            dialog.componentInstance.message = "Seçilen sözleşmeyi silmek istediğinize emin misiniz?"
            dialog.componentInstance.confirmed.subscribe(async(x)=>{
                await this._companyService.deleteCustomFuelInformation(cfi);
                dialog.close();
            })
            dialog.componentInstance.rejected.subscribe(async (x:any) => {
                dialog.close();
            })
            
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);
            this._toasterService.toastFail();
        }
        this.refresh();
    }

    async FuelStatusChange(fuel: CustomFuelInformation) {
        fuel.status = !fuel.status
        var statusControl = this.fuelInformationList.filter(e => e.status == true);
        if (statusControl.length > 1) {
            this._toasterService.toastWarning(this._translateService.instant("THERE_IS_ALREADY_AN_ACTIVE_FUEL_INFORMATION"))
            fuel.status = !fuel.status
            return;
        }
        try {
            await this._companyService.updateCustomFuelInformation(fuel);
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);
        }
        this.refresh();
    }
    refresh() {
        this.getFuelInformation();
    }
}
